module.exports = __webpack_public_path__ + "cea857e4b787257b4b356c854c834a84.png";